import { memo } from "react";
import { HStack } from "@/shared/ui/Stack";
import { TEXT_ALIGN_ICONS } from "../../constants/textAlignIcons";
import { MenuButton } from "../MenuButton/MenuButton";

interface TextAlignMenuContentProps {
    onTextAlignButtonClick: (align: string) => void;
}

export const TextAlignMenuContent = memo(function TextAlignMenuContent({
    onTextAlignButtonClick,
}: TextAlignMenuContentProps) {
    return (
        <HStack gap={2}>
            {Object.entries(TEXT_ALIGN_ICONS).map(([align, Icon]) => (
                <MenuButton key={align} onClick={() => onTextAlignButtonClick(align)}>
                    <Icon />
                </MenuButton>
            ))}
        </HStack>
    );
});
